import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2 } from 'lucide-react';
const tomos = [{
  num: '1',
  title: 'EL MAPA DEL FREELANCER',
  desc: 'Del empleado sin ingresos extra al freelancer con sistema. Entendé cómo funciona el mercado global de servicios digitales. Elegí tu posición de arranque. Plan de acción de 7 días para empezar esta semana.',
  color: 'text-electric',
  bg: 'bg-electric/10',
  border: 'border-electric',
  shadow: 'shadow-[0_0_20px_rgba(245,185,66,0.5)] hover:shadow-[0_0_35px_rgba(245,185,66,0.85)]'
}, {
  num: '2',
  title: 'ELEGÍ TU SERVICIO GANADOR',
  desc: 'El método para identificar qué podés ofrecer hoy sin experiencia previa. Los 6 servicios más demandados en Latam. Tabla de tarifas reales. Tu servicio empaquetado y listo para vender en 24 horas.',
  color: 'text-energy',
  bg: 'bg-energy/10',
  border: 'border-energy',
  shadow: 'shadow-[0_0_20px_rgba(0,230,118,0.5)] hover:shadow-[0_0_35px_rgba(0,230,118,0.85)]'
}, {
  num: '3',
  title: 'ARMÁ TU PERFIL QUE VENDE',
  desc: 'Configuración paso a paso de Workana, Fiverr y LinkedIn. El sistema de 5 bloques para escribir una descripción que convierte. Cómo crear un portafolio sin proyectos previos. Foto, título y keywords que posicionan.',
  color: 'text-gold',
  bg: 'bg-gold/10',
  border: 'border-gold',
  shadow: 'shadow-[0_0_20px_rgba(255,209,102,0.5)] hover:shadow-[0_0_35px_rgba(255,209,102,0.85)]'
}, {
  num: '4',
  title: 'DÓNDE CONSEGUIR CLIENTES',
  desc: 'Los 5 canales donde están los clientes que te van a pagar. Sistema de alertas de proyectos en tiempo real. Cómo activar tu red personal en 48 horas. El protocolo de búsqueda de 45 minutos diarios.',
  color: 'text-emerald-400',
  bg: 'bg-emerald-400/10',
  border: 'border-emerald-400',
  shadow: 'shadow-[0_0_20px_rgba(52,211,153,0.5)] hover:shadow-[0_0_35px_rgba(52,211,153,0.85)]'
}, {
  num: '5',
  title: 'CONSEGUÍ TUS PRIMERAS RESPUESTAS',
  desc: 'La anatomía de la propuesta perfecta en 6 bloques. 12 scripts listos para copiar y usar hoy. Sistema de personalización de 3 minutos. Los 7 errores que matan propuestas. Plan de 72 horas para tu primera respuesta.',
  color: 'text-amber-400',
  bg: 'bg-amber-400/10',
  border: 'border-amber-400',
  shadow: 'shadow-[0_0_20px_rgba(251,191,36,0.5)] hover:shadow-[0_0_35px_rgba(251,191,36,0.85)]'
}, {
  num: '6',
  title: 'CERRÁ Y COBRÁ TU PRIMER CLIENTE',
  desc: 'Cómo cerrar sin presionar. Negociación sin perder valor. El mini-contrato que te protege. Guía completa para cobrar en dólares desde Argentina. La entrega que genera reseñas de 5 estrellas.',
  color: 'text-usd',
  bg: 'bg-usd/10',
  border: 'border-usd',
  shadow: 'shadow-[0_0_20px_rgba(0,230,118,0.5)] hover:shadow-[0_0_35px_rgba(0,230,118,0.85)]'
}];
const inclusions = ['Scripts y templates listos para copiar y usar', 'Checklists, tablas y plantillas accionables', 'Diseñado para el mercado argentino y latinoamericano', 'Aplicable desde el primer día sin experiencia técnica', 'Lenguaje claro, directo y sin tecnicismos'];
export function TomosSection() {
  return <section className="py-14 bg-petroleum/30 border-y border-electric/10" data-id="element-696">
      <div className="container mx-auto px-4" data-id="element-697">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-698">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-gold to-electric rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-699"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/30" data-id="element-700">
            {/* Grid pattern background */}
            <div className="absolute inset-0 opacity-[0.10] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(245,185,66,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(245,185,66,0.7) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-701"></div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-702"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-703"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-704"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-705"></div>

            <div className="relative z-10" data-id="element-706">
              <div className="inline-flex items-center gap-2 bg-electric text-graphite font-extrabold tracking-widest uppercase text-xs px-4 py-1.5 rounded-full mb-5 shadow-lg shadow-electric/40" data-id="element-707">
                <span className="w-6 h-px bg-graphite" data-id="element-708"></span>
                El Sistema Completo
                <span className="w-6 h-px bg-graphite" data-id="element-709"></span>
              </div>
              <h2 className="text-3xl md:text-5xl font-extrabold mb-4" data-id="element-710">
                🏆 MEGAPACK FREELANCER:
                <br data-id="element-711" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-gold to-electric drop-shadow-[0_0_12px_rgba(245,185,66,0.4)]" data-id="element-712">
                  FACTURÁ TUS PRIMEROS USD
                </span>
              </h2>
              <div className="mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70 mb-4" data-id="element-713"></div>
              <p className="text-lg md:text-xl text-textsecondary" data-id="element-714">
                6 Tomos + 6 Bonos — El Sistema Completo para Generar Ingresos en
                Dólares desde Argentina ·{' '}
                <span className="text-white font-bold" data-id="element-715">
                  300+ páginas. Todo resuelto.
                </span>
              </p>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-716">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-petroleum rounded-2xl p-6 border-2 ${tomo.border} ${tomo.shadow} transition-all duration-300 group relative overflow-hidden hover:-translate-y-1`} data-id="element-717">
              <div className={`absolute top-0 right-0 w-32 h-32 ${tomo.bg} blur-3xl rounded-full -mr-10 -mt-10 transition-opacity group-hover:opacity-100 opacity-50`} data-id="element-718"></div>

              <div className="flex items-center gap-4 mb-6 relative z-10" data-id="element-719">
                <div className={`w-12 h-12 rounded-xl ${tomo.bg} ${tomo.color} flex items-center justify-center font-bold text-xl`} data-id="element-720">
                  {tomo.num}
                </div>
                <BookOpen className={`w-6 h-6 ${tomo.color} opacity-50`} data-id="element-721" />
              </div>

              <h3 className="text-lg font-bold mb-3 relative z-10" data-id="element-722">
                Tomo {tomo.num} — {tomo.title}
              </h3>
              <p className="text-textsecondary text-sm leading-relaxed relative z-10" data-id="element-723">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="max-w-3xl mx-auto bg-graphite rounded-2xl p-8 border border-electric/20" data-id="element-724">
          <h4 className="text-center font-bold text-xl mb-6" data-id="element-725">
            Cada tomo incluye:
          </h4>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-726">
            {inclusions.map((inc, i) => <div key={i} className="flex items-start gap-3" data-id="element-727">
                <CheckCircle2 className="w-5 h-5 text-electric shrink-0 mt-0.5" data-id="element-728" />
                <span className="text-textsecondary text-sm" data-id="element-729">{inc}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}